import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBrain, FiHeart, FiRefreshCw } = FiIcons;

const Benefits = () => {
  const goals = [
    {
      icon: FiBrain,
      title: "Deinkopf darf loslassen",
      description: "Das Gedankenkarussell wird leiser.\nDein Geist wird klarer und du spürst wieder Raum in dir."
    },
    {
      icon: FiHeart,
      title: "Dein Körper findet Gleichgewicht",
      description: "Verspannungen lösen sich behutsam.\nDein Nervensystem kommt in eine ruhige, ausgeglichene Haltung."
    },
    {
      icon: FiRefreshCw,
      title: "Du findest zurück zu dir",
      description: "Du musst nichts erreichen und niemandem etwas beweisen.\nEs darf einfach gut sein, so wie es ist."
    }
  ];

  return (
    <section id="benefits" className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#F9F5F0' }}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-serif mb-6" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
            Tiefer wirken lassen – statt einfach nur abschalten
          </h2>
          <p className="text-lg max-w-3xl mx-auto leading-relaxed mb-12" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
            Wenn du zur Ruhe kommst, kann dein Nervensystem entspannen – ganz ohne etwas leisten zu müssen.<br />
            Yin und Klang wirken sanft und tief. Dein Körper weiß, was zu tun ist.
          </p>

          {/* Testimonial Tile Maike */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="p-8 rounded-2xl shadow-lg border max-w-4xl mx-auto mb-16"
            style={{ backgroundColor: '#FFFFFF', borderColor: '#CBB8A9' }}
          >
            <div className="text-center">
              <p className="text-stone-800 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                <span className="block font-semibold mb-3 text-lg" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
                  Maike, Teilnehmerin:
                </span>
                <span className="italic text-base" style={{ color: '#2C2C2C' }}>
                  „Normalerweise fällt es mir unglaublich schwer, loszulassen, weil mein Kopf ständig arbeitet. Doch die sanften Schwingungen der Klangschalen haben mein Gedankenkarussell einfach still werden lassen. Eine Übung fühlte sich plötzlich an wie nur eine Minute.“
                </span>
              </p>
            </div>
          </motion.div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759856723037-yin_pose_ruhend.jpg" 
              alt="Ruhende Yin-Yoga-Pose mit Hilfsmitteln" 
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center"
          >
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {goals.map((goal, index) => (
                <motion.div
                  key={goal.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.02, x: 10 }}
                  className="p-6 rounded-2xl shadow-lg border"
                  style={{ backgroundColor: '#FFFFFF', borderColor: '#CBB8A9' }}
                >
                  <div className="flex items-start">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4 flex-shrink-0" style={{ backgroundColor: '#CBB8A9' }}>
                      <SafeIcon icon={goal.icon} className="w-6 h-6" style={{ color: '#314C40' }} />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>{goal.title}</h3>
                      <p className="leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>{goal.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
              className="text-center mt-8 text-lg"
              style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}
            >
              Jede Stunde ist ein geschützter Raum – du darfst so sein, wie du bist.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;